import { TCpdAvailableState, TCpdState } from '../../types/cpd/cpd';
import { ECpdActionTypes } from '../../actions/cpd/actions';
import { TReduxActions } from '../../types/redux';

const defaultState: TCpdState = {
  isAvailable: false,
};

export function cpdReducer(state: TCpdState = defaultState, action: TReduxActions): TCpdState {
  switch (action.type) {
    case ECpdActionTypes.SetCpdModalOpen:
      return {
        ...state,
        isModalOpen: action.payload,
      } as TCpdAvailableState;

    default:
      return state;
  }
}
